export default "__VITE_ASSET__daa8f43d__"